import { Text } from "@chakra-ui/react";
import React from "react";

const Small = ({ children, textStyle="primary", fontSize="12px!important", fontWeight="400",lineHeight="14px",  ...props }) => {
  return (
    <Text
      as="p"
      {...props}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      textStyle={textStyle}
    >
      {children}
    </Text>
  );
};
export default React.memo(Small);
